<template>
  <div class="footers">
    <div class="wrapper">
      <div class="f-logo"><img alt="广西教育出版" src="../../assets/image/footer/footer.png"></div>
      <div class="f-box">
        <h3>友情链接</h3>
        <ul>
          <li><a href="https://yywz.gxeduyun.edu.cn/" target="_blank">广西语言文字网</a></li>
          <li><a href="http://gj.gxlib.org.cn/" target="_blank">广西古籍保护网</a></li>
          <li><a href="http://www.gxlib.org.cn/" target="_blank">广西壮族自治区图书馆</a></li>
          <li><a href="http://www.gxmuseum.cn/" target="_blank">广西壮族自治区博物馆</a></li>
          <li><a href="http://www.cpon.cn/" target="_blank">民族文化宫</a></li>
          <li><a href="https://www.cnmuseum.com/" target="_blank">中国民族博物馆</a></li>
          <li><a href="http://www.guji.cn/" target="_blank">中华古籍网</a></li>
          <li><a href="http://www.nlc.cn/pcab/" target="_blank">中国古籍保护网</a></li>
          <li><a href="http://www.chinaabp.cn/" target="_blank">中国古籍保护协会</a></li>
        </ul>
      </div>
      <div class="f-box">
        <h3>联系我们</h3>
        <p><span class="label">地址：</span>南宁市鲤湾路8号</p>
        <p><span class="label">邮编：</span>530022 </p>
        <p><span class="label">电话：</span>0771-5850244、0771-5852408</p>
      </div>
      <div class="f-box">
        <h3>关注我们</h3>
        <div class="codes">
          <div class="code">
            <el-image :src="require('../../assets/image/footer/code1.jpg')" alt="广西古籍文库" fit="fill"></el-image>
            <div style="text-align: center;"> 广西古籍文库</div>
          </div>
          <div class="code">
            <el-image :src="require('../../assets/image/footer/code2.jpg')" alt="广西古籍文库" fit="fill"></el-image>
            <div style="text-align: center;"> 广西教育出版社</div>
          </div>
        </div>
      </div>
      <div class="f-box">
        <h3>共建单位</h3>
        <div>广西壮族自治区少数民族古籍保护研究中心</div>
        <div>广西民族语文研究中心</div>
        <div>广西民族出版社</div>
        <div>广西人民出版社有限公司</div>
        <div>漓江出版社有限公司</div>
        <div>广西教育出版社有限公司</div>
        <div>广西科学技术出版社有限公司</div>
        <div>广西美术出版社有限公司</div>
        <div>接力出版社有限公司</div>
        <div>广西金海湾电子音像出版社有限公司</div>
      </div>
    </div>
    <div class="bottom">
      <div class="wrapper"><span>版权所有© 广西教育出版社有限公司 All Rights Reserved</span>
        <span style=" color:#939393;">网络出版服务许可证: (署) 网出证 (桂)字第023号</span>
        <span><a href="http://beian.miit.gov.cn" target="_blank" style=" color:#939393;">桂ICP备12006018号</a></span>
        <span>
          <a target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo" style="display:inline-block;text-decoration:none;"><img :src="require('../../assets/image/footer/code3.png')" style="float:left;top: 50%;"/><p style="float:left;margin: 0px 0px 0px 5px; color:#939393;">桂公网安备 45010302003116号</p></a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PortalFooter',

    data() {
      return {}
    },

    mounted() {

    },

    methods: {},
  };
</script>
<style lang="less" scoped>
  .footers {
    width: calc(100% - 20.885rem - 19.844rem);
    margin: 0 auto;
    padding: 2rem 0;
    font-family: Microsoft YaHei;

    .wrapper {
      display: flex;
      justify-content: center;

      .f-logo {
        margin-right: 3rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .f-box {
        width: 310px;
        margin-right: 20px;
        line-height: 30px;
        text-align: left;
        color: #333;

        h3 {
          margin-bottom: 25px;
          font-size: 18px;
          color: #000;
        }

        ul {
          list-style: none;

          li {
            float: left;
            width: 135px;
            padding-right: 20px;
            font-size: 11.9px;
            overflow: hidden;
            white-space: nowrap;
          }

          a {
            color: #636363;
            text-decoration: none;
          }
        }

        p {
          font-size: 11.9px;
        }

        .codes {
          display: flex;

          .code {
            display: block;
            font-size: 11.9px;
            line-height: 35px;

            .el-image {
              width: 100px;
              height: 100px;
              vertical-align: top;
            }
          }

        }
      }
    }

    .bottom {
      // height: 50px;
      // line-height: 50px;
      border-top: 1px solid #d5cab5;
      font-size: 14px;
      padding-top: 20px;
      span {
        margin: 0 20px;

        a {
          color: #333;
          text-decoration: none;
        }
      }
    }
  }
</style>
